var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.40399L6 7.94999V23.784C6.00432 26.8744 6.73747 29.9202 8.13993 32.674C9.54239 35.4278 11.5746 37.812 14.0715 39.633L24 46.854L33.9285 39.633C36.4254 37.812 38.4576 35.4278 39.8601 32.674C41.2625 29.9202 41.9957 26.8744 42 23.784V7.94999L24 1.40399ZM39 23.784C38.9959 26.4013 38.3748 28.9807 37.1871 31.313C35.9995 33.6453 34.2787 35.6647 32.1645 37.2075L24 43.146L15.8355 37.2075C13.7213 35.6647 12.0005 33.6453 10.8129 31.313C9.62523 28.9807 9.00414 26.4013 9 23.784V10.05L24 4.59599L39 10.05V23.784Z",
    fill: "#2B7BFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5605 20.3145L15.4395 22.4355L22.125 29.121L32.5605 18.6855L30.4395 16.5645L22.125 24.879L17.5605 20.3145Z",
    fill: "#2B7BFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.db67be5389a6ef926318c6b83591729c.svg";
export { ForwardRef as ReactComponent };